<template>
<section class="timeline">
	<section class="text">
		<div class="container">
			<p>While planning this project, it was highly important to us that we grant our supporters early access to all our Project DEIOS development stages. Therefore, our timeline includes several stages of development releases to keep waiting time
				short, while at the same time enabling room for early feedback and improvement.
			</p>
			<p>
				For more details and updates on our development cycle visit our page on kickstarter.
			</p>
		</div>
		<div class="text-center mt2">
			<a href="https://www.kickstarter.com/projects/dungeonfog/project-deios-dungeonfog-mapmaker-suite-for-worldbuilders/posts" class="button-sub">Project Deios Update Blog</a>
		</div>
	</section>
	<section class="image">
		<div class="container">
			<img class="desktop" src="~@/assets/img/img_timeline.webp" alt="Timeline">
			<img class="mobile" src="~@/assets/img/img_timeline_mobile.webp" alt="Timeline">
		</div>
		<div class="container mt">
			<img class="desktop" src="~@/assets/img/img_deios_roadmap.webp" alt="Roadmap">
		</div>
	</section>
</section>
</template>

<script>
export default {
	name: 'SectionTimeline',
}
</script>
